/* eslint-disable react/prop-types */
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const TEAL = '#00798E';

/**
 * Searchable dropdown — drop-in replacement for <Select>.
 *
 * Props:
 *   options   : [{ value, label }]  or  [string]
 *   value     : current value (matches option.value or string)
 *   onChange  : (value) => void
 *   label     : string
 *   placeholder : string
 *   disabled  : bool
 *   size      : 'small' | 'medium'
 *   sx        : MUI sx
 *   fullWidth : bool
 */
export default function SearchableSelect({
  options = [],
  value,
  onChange,
  label,
  placeholder,
  disabled,
  size = 'small',
  sx = {},
  fullWidth = true,
}) {
  const normalized = options.map((o) =>
    typeof o === 'string' ? { value: o, label: o } : o
  );

  const selected = normalized.find((o) => String(o.value) === String(value ?? '')) || null;

  return (
    <Autocomplete
      options={normalized}
      value={selected}
      disabled={disabled}
      fullWidth={fullWidth}
      getOptionLabel={(o) => o.label || ''}
      isOptionEqualToValue={(o, v) => String(o.value) === String(v?.value ?? '')}
      onChange={(_, newVal) => onChange(newVal ? newVal.value : '')}
      componentsProps={{ popper: { sx: { zIndex: 9999 } } }}
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          label={label}
          placeholder={placeholder}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: size === 'small' ? 34 : 44,
              fontSize: '0.82rem',
              '&.Mui-focused fieldset': { borderColor: TEAL },
            },
            ...sx,
          }}
        />
      )}
    />
  );
}
